import { useEffect, useState } from 'react';

import { DonutChart } from 'src/lib';
import { AccountBalanceSummaryView, AccountBalanceSummaryViewField } from 'src/models';

import { Color } from '../../styles';

interface BalanceSummaryChartProps {
  accountValue: number;
  summary: AccountBalanceSummaryView;
}

export const BalanceSummaryChart = ({ summary, accountValue }: BalanceSummaryChartProps) => {
  const [totalValues, setTotalValues] = useState<number[]>([]);
  const [colors, setColors] = useState<string[]>([]);

  useEffect(() => {
    const totalValues: number[] = [];
    const colors: string[] = [];
    Object.entries(summary)?.forEach(([, info]: [string, AccountBalanceSummaryViewField]) => {
      totalValues.push(
        info?.value !== null && !Number.isNaN(info?.value) && info?.value !== undefined ? info.value : 0,
      );
      colors.push(info.color);
    });

    renderEmptyState(totalValues, colors);
    setTotalValues(totalValues);
    setColors(colors);
  }, [summary]);

  const renderEmptyState = (totalValues: number[], colors: string[]) => {
    if (totalValues.every(item => item === 0)) {
      totalValues.push(1);
      colors.push(Color.GRAYSCALE.GRAY6);
    }
  };

  return <DonutChart total={accountValue} data={totalValues} colors={colors} />;
};
